import React, { useMemo } from 'react'
import { gql, useQuery } from '@apollo/client'

import { Query, QueryAreaArgs } from 'graphqlAPI'
import { ChildFilterTypes } from 'enum'
import { ApplyFiltersByType } from '../types'
import { GeneralProgress } from './GeneralProgress'

const AREA_ADVANCEMENT = gql`
  query AreaAdvancement($id: ID!, $q: AreaRansack) {
    area(id: $id, q: $q) {
      coursesCount
      participantsCount
      participantsProgress {
        finish
        inProgress
        pending
      }
      coursesDominantProgress {
        finish
        inProgress
        pending
      }
    }
  }
`

interface AreaProgressProps {
  areaId: string | number
  applyFiltersByType: ApplyFiltersByType
  skip?: boolean
}

export const AreaProgress: React.FC<AreaProgressProps> = ({
  areaId,
  applyFiltersByType,
  skip = false,
}) => {
  const g = useMemo(
    () => applyFiltersByType(ChildFilterTypes.Area),
    [applyFiltersByType]
  )

  const { loading, data } = useQuery<
    Pick<Query, 'area' | '__typename'>,
    QueryAreaArgs
  >(AREA_ADVANCEMENT, {
    variables: {
      id: areaId.toString(),
      q: {
        g: g.filters,
      },
    },
    fetchPolicy: 'cache-and-network',
    skip,
  })

  const area = data?.area

  return (
    <GeneralProgress
      data={
        area
          ? {
              participantsAdvance: area.participantsProgress,
              coursesAdvance: area.coursesDominantProgress,
              participantsCount: area.participantsCount,
              coursesCount: area.coursesCount,
            }
          : undefined
      }
      loading={loading}
    />
  )
}
